let switchByScroll = (direction) => {
    let wS = $(window).scrollTop(),
        section = $('*[data-switch-by-scroll]'),
        res = resolutionCheck(),
        hH = $('.main-header__sticky-wrapper').outerHeight(),
        sideTabsH = $('.js-side-tabs').outerHeight();
    section.each(function() {
        let arr = $(this).attr('data-switch-by-scroll').split(' '),
            target = $('#' + arr[0]),
            additionalOffset,
            resRatio = arr[2];

        if (direction == 0) {
            // scroll down
            if (res < 120) {
                additionalOffset = sideTabsH;

            } else {
                additionalOffset = 0;
            }
            // if (wS >= $(this).offset().top - hH / 0.5 - additionalOffset) {
            if (wS >= $(this).offset().top - additionalOffset - 5) {
                target
                    .addClass('active')
                    .closest('.side-tabs__item')
                    .siblings()
                    .find('.js-switch-by-scroll')
                    .removeClass('active');
            } else {
                target.removeClass('active');
            }
        } else if (direction == 1) {
            // scroll up
            if (res < 120) {
                additionalOffset = sideTabsH;
            } else {
                additionalOffset = 0;
            }
            if (wS >= $(this).offset().top - hH / 0.5 - additionalOffset - 5) {
                target
                    .addClass('active')
                    .closest('.side-tabs__item')
                    .siblings()
                    .find('.js-switch-by-scroll')
                    .removeClass('active');
            } else {
                target.removeClass('active');
            }
        }
    });
};

let directionScroll,
    lastScrollTopPos = 0;
$(document).ready(function() {
    if ($('*[data-switch-by-scroll]').length) {
        directionScroll = 1;
        switchByScroll(directionScroll);
    }
});

$(window).on('scroll', function() {
    if ($('*[data-switch-by-scroll]').length) {
        let wST = $(this).scrollTop();
        if (wST > lastScrollTopPos) {
            // downscroll
            directionScroll = 0;
            switchByScroll(directionScroll);
        } else {
            // upscroll
            directionScroll = 1;
            switchByScroll(directionScroll);
        }
        lastScrollTopPos = wST;
    }
});
